
import {createContext, useState} from 'react'

const Context = createContext()

export const NivelesEstructureContextProvider = ({children}) => {
 const [allNivelesEstructure, setAllNivelesEstructure] = useState([])
 const [nivelesEstructure, setNivelesEstructure] = useState([]);
 const [nivelEstructure, setNivelEstructure] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allNivelesEstructure, setAllNivelesEstructure, nivelesEstructure, setNivelesEstructure, nivelEstructure, setNivelEstructure, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context